import React, { HTMLAttributes } from "react";
import cx from "classnames";

import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Business: React.FC<Props> = ({ className }) => {
  const t = useTranslation();
  // const {isLogin} = store.user;

  return (
    <div className={cx(`${styles.schedulebg}`, className)} style={{ backgroundImage: `url(${require("@/assets/images/common/schedulebg.png")})`}}>
        <div>
            <p className={cx(`${styles.schedulebgTit}`, className)}>{t('cmpt.schedule')}</p>
            <p className={cx(`${styles.schedulebgCon}`, className)}>{t('account.Quicklycheck')}</p>
        </div>
    </div>
  );
};

export default Business;